import React, { useEffect } from "react";
import { colorValue } from "../../css/color";
import { styled } from "../../stitches.config";
import { CursorType } from "../../types";

const cursorPath =
  "M2.5,5.1C2,3.5,3.5,2,5.1,2.5l10.5,3.5c1.7,0.6,1.8,2.9,0.3,3.7l-3.1,1.6c-0.6,0.3-1.1,0.8-1.3,1.3l-1.6,3.1c-0.8,1.6-3.1,1.4-3.7-0.3L2.5,5.1z";
const pointerPath =
  "M6.50,12.0 h-4.764c-0.212,0,-0.384,-0.172,-0.384,-0.384v-0.604c0,-0.161,-0.1,-0.305,-0.251,-0.36l-0.735,-0.27c-0.061,-0.023,-0.116,-0.061,-0.159,-0.111l-1.298,-1.52l-0.032,-0.047l-1.098,-1.43c-1.704,-2.269,0.419,-4.202,2.095,-2.274l0.29,0.35l-1.376,-3.892c-0.99,-2.418,1.475,-3.835,2.635,-0.875l0.255,0.551c0,0,0.279,0.558,0.456,1.328c0.082,0.356,0.152,1.003,0.151,0.923c-0.001,-0.081,0,-0.849,0,-0.849c-0.103,-1.978,2.58,-2.28,2.678,-0.384c0.008,0.155,0.014,0.282,0.018,0.384c0.306,-1.415,2.846,-1.283,2.846,0.363c0,0,-0.044,0.737,-0.044,0.805c0,0.053,0.059,0.022,0.095,-0.016c0.649,-0.699,2.433,0.154,1.608,1.813c-0.493,0.992,-0.603,1.248,-0.627,1.295l-1.329,3.446c-0.029,0.069,-0.079,0.127,-0.141,0.169l-0.333,0.219c-0.108,0.071,-0.173,0.191,-0.173,0.32v0.666c0,0.212,-0.171,0.384,-0.383,0.384z";
const grabPath =
  "M3.7,6.5h-4.764c-0.212,0,-0.384,-0.172,-0.384,-0.383l0,-0.605c0,-0.161,-0.1,-0.305,-0.251,-0.36l-0.734,-0.27c-0.062,-0.023,-0.117,-0.061,-0.16,-0.111l-1.298,-1.52l-0.032,-0.047l-1.098,-1.43c-1.704,-2.269,0.419,-4.202,2.095,-2.274l0.29,0.35l-1.376,-3.892c-0.99,-2.419,1.579,-3.838,2.635,-0.875l0.002,0.006l0.788,1.844c0,0,0.056,0.16,0.055,0.08c-0.002,-0.08,-0.292,-3.707,-0.292,-3.707c-0.128,-2.463,2.774,-2.628,2.902,-0.151l0.122,2.337c0,0,0.084,1.265,0.102,1.448c0.018,0.184,0,-1.775,0,-1.775c0,-2.862,2.839,-2.935,2.839,0l0,2.27c0,0.107,0.047,-0.021,0.055,-0.044l0.002,-0.007c0.736,-2.3,3.534,-1.517,2.28,1.197c-0.465,1.006,-0.961,1.995,-0.985,2.043l-1.763,4.118c-0.029,0.069,-0.078,0.127,-0.141,0.169l-0.333,0.219c-0.108,0.071,-0.172,0.191,-0.172,0.32l0,0.667c0,0.211,-0.172,0.383,-0.384,0.383z";
const grabbingPath =
  "M3.7,6.5h-4.764c-0.212,0,-0.384,-0.172,-0.384,-0.383v-0.605c0,-0.161,-0.1,-0.305,-0.251,-0.36l-0.734,-0.27c-0.062,-0.023,-0.117,-0.061,-0.16,-0.111l-1.298,-1.52l-0.014,-0.021c-0.012,-0.017,-0.023,-0.036,-0.032,-0.055l-0.66,-1.406c-0.988,-1.579,0.706,-3.079,1.877,-2.002l0.084,0.083l-0.533,-1.366c-0.761,-1.808,1.555,-2.944,2.415,-1.12l0.096,0.237l0.071,0.099c0,0,0.056,0.16,0.055,0.08c-0.002,-0.08,-0.126,-1.275,-0.126,-1.275c-0.103,-1.97,2.77,-1.916,2.86,-0.176c0.058,1.112,0.068,1.011,0.071,1.063c0,0,0.011,0.132,0.029,0.315c0.018,0.184,0,-0.625,0,-0.625c0,-1.637,3.114,-1.808,2.839,0.767c0,0,-0.048,0.431,-0.048,0.471c0,0.025,0.086,-0.046,0.151,-0.104c0.049,-0.042,0.106,-0.075,0.169,-0.087c1.131,-0.226,2.014,0.748,1.293,2.123c-0.152,0.289,-0.189,0.324,-0.213,0.372l-1.763,4.118c-0.029,0.069,-0.078,0.127,-0.141,0.169l-0.333,0.219c-0.108,0.071,-0.173,0.191,-0.173,0.32v0.666c0,0.212,-0.171,0.384,-0.383,0.384z";
const penPath =
  "M11.5,10.5c0.361,0.43,-0.355,1.603,-1.272,2.373c-0.918,0.77,-2.237,1.224,-2.558,0.841m5.758,-0.916c-0.291,-0.347,-5.223,-6.224,-6.138,-7.315c-0.096,-0.115,-0.216,-0.206,-0.352,-0.268l-3.164,-1.437c-0.765,-0.347,-1.591,0.346,-1.382,1.16l0.866,3.365c0.037,0.145,0.106,0.279,0.202,0.393c0.915,1.091,5.847,6.969,6.138,7.316c0.322,0.383,1.515,0.034,2.558,-0.841c1.043,-0.875,1.594,-1.99,1.272,-2.373z";
const resizePathNW =
  "M7.0235,3.31036c0.14,-0.14,0.38,-0.031,0.365,0.167l-0.299,3.965c-0.008,0.108,-0.096,0.194,-0.205,0.198l-3.821,0.155c-0.195,0.008,-0.298,-0.227,-0.16,-0.365l1.268,-1.268c0.083,-0.083,0.083,-0.219,0,-0.302l-7.045,-7.045c-0.083,-0.083,-0.219,-0.083,-0.302,0l-1.268,1.267c-0.138,0.138,-0.373,0.035,-0.365,-0.16l0.158,-3.817c0.005,-0.109,0.09,-0.197,0.198,-0.205l3.961,-0.302c0.198,-0.015,0.308,0.225,0.167,0.365l-1.246,1.247c-0.084,0.083,-0.084,0.219,0,0.303l7.044,7.044c0.084,0.084,0.219,0.084,0.303,0l1.247,-1.247z";
const resizePathNE =
  "m0.0768406,5.630346c0.14044,0.1404,0.03057,0.3798,-0.16748,0.3649l-3.96465999,-0.2988c-0.1083,-0.0081,-0.1934,-0.0962,-0.1978,-0.2048l-0.1554,-3.8212104c-0.0079,-0.19481,0.2275,-0.29796,0.3653,-0.16009l1.26779999,1.26771c0.0836,0.08362,0.2191,0.08362,0.3027,0l7.04441,-7.04437c0.08362,-0.08361,0.08362,-0.21917,0,-0.30279l-1.26724,-1.267242c-0.13793,-0.137926,-0.03462,-0.3734,0.16027,-0.365314l3.8172904,0.158372c0.10845,0.004498,0.19637,0.089432,0.20461,0.197657l0.301727,3.960647c0.01509,0.19812,-0.224377,0.30816,-0.364877,0.16766l-1.24652,-1.24652c-0.08361,-0.08361,-0.21917,-0.08361,-0.30279,0l-7.044,7.044c-0.08361,0.0836,-0.08361,0.2192,0,0.3028z";
const textPath =
  "M-1,6.8112962 h4.333c0.341,0,0.519,-0.163,0.519,-0.438c0,-0.282,-0.178,-0.43,-0.519,-0.43h-1.662v-13.718h1.662c0.341,0,0.519,-0.156,0.519,-0.438c0,-0.274,-0.178,-0.423,-0.519,-0.423h-4.333c-0.334,0,-0.512,0.149,-0.512,0.423c0,0.282,0.178,0.438,0.512,0.438h1.669v13.718h-1.669c-0.334,0,-0.512,0.148,-0.512,0.43c0,0.275,0.178,0.438,0.512,0.438z";

const cursorPaths = {
  default: cursorPath,
  pointer: pointerPath,
  text: textPath,
  grab: grabPath,
  grabbing: grabbingPath,
  pen: penPath,
  "nwse-resize": resizePathNW,
  "nesw-resize": resizePathNE,
};

export const DefaultCursor = React.memo(function DefaultCursor({
  color = "#040404",
  cursor = "default",
}: {
  color: string;
  cursor: CursorType;
}) {
  useEffect(() => {
    document.body.style.cursor = "none";
    return () => {
      document.body.style.cursor = "auto";
    };
  }, []);

  const path = (cursorPaths as any)[cursor] ?? cursorPath;

  const thin =
    cursor === "text" || cursor === "nesw-resize" || cursor == "nwse-resize";
  if (thin) {
    color = colorValue("paper", 10);
  }
  return (
    <SvgContainer>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        overflow="visible"
      >
        <defs>
          <filter id="shadow" height="300%" y="-100%" width="300%" x="-100%">
            <feDropShadow
              dx="0"
              dy="1"
              stdDeviation="2"
              floodColor="black"
              floodOpacity=".50"
            />
          </filter>
        </defs>
        <path
          d={path}
          fill={color}
          style={{
            filter: "url(#shadow)",
          }}
        />
        <WhiteOutline d={path} strokeWidth={thin ? "4px" : "6px"} />
        <path d={path} fill={color} />
        <BrownInstroke d={path} strokeWidth="1" />
      </svg>
    </SvgContainer>
  );
});

const SvgContainer = styled("div", {
  position: "absolute",
  top: 0,
  left: 0,
  pointerEvents: "none",
});

const WhiteOutline = styled("path", {
  stroke: "white",
});

const BrownInstroke = styled("path", {
  stroke: "$paper10",
});
